import React, { useState, useEffect }               from 'react'
import { withRouter }                               from 'react-router-dom'
import { connect }                                  from 'react-redux'
import usePackage                                   from '../hooks/usePackage'
import GlobalFooter                                 from '../components/GlobalFooter'
import GlobalError                                  from '../components/GlobalError'
import CustomerSidebar                              from '../components/CustomerSidebar'
import CustomerLoading                              from '../components/CustomerLoading'

import {
  convertToClientTimestamp,
  displayDate,
  handleError,
}                                                   from '../common/utils'

import {
  warehouseData,
  weightImperial,
  dimensionsImperial,
  carrierLabel,
  GREEN_STATUS,
  YELLOW_STATUS,
  RED_STATUS,
  restrictionStatus
}                                                   from '../common/constants'

import { PageHeader} from 'antd'
import ItemsDeclarationForm from "../components/ItemsDeclarationForm";
import PhotoModal from "../components/PhotoModal";
import RequestPhotoModal from "../components/RequestPhotoModal";
import MobileDeclarationForm from "../components/MobileDeclarationForm";
import CancelConsolidationModal from '../components/CancelConsolidationModal'
import withAddressAutocomplete from '../hocs/withAddressAutocomplete'
import TrackingLink from '../components/TrackingLink'
import TimelineModal from "../components/Timeline/TimelineModal";
import CancelPrereceiveModal from "../components/Prereceiving/CancelPrereceiveModal";

const mapStateToProps = (globalStore) => {
  return { store: globalStore }
}

const mapDispatchToProps = (dispatch) => {
  return {
    logout: () => {
      dispatch({ type: 'CUSTOMER_LOGOUT' })
    },
    setWarehouse: (w) => {
      dispatch({ type: 'SET_WAREHOUSE', payload: w })
    },
  }
}

const Checkout = props => {

  const [initialLoading, setInitialLoading] = useState(0)
  const [page, setPage] = useState(1)
  const [pkg, setPkg] = useState({})
  const [items, setItems] = useState([])
  const [customsType, setCustomsType] = useState(1)
  const [paymentScreen, setPaymentScreen] = useState(false)
  const [editDeclarationForm, setEditDeclarationForm] = useState(true)
  const [fees, setFees] = useState({
    giftWrap: null,
    invoiceRemoval: null,
    padding: null,
  })
  const [shippingAddrState, setShippingAddrState] = useState(false)
  const [returnOption, setReturnOption] = useState(false)
  const [dimensionInInch, setDimensionInInch] = useState(true)
  const [weightInLb, setWeightInLb] = useState(true)
  const [modalScreen, setModalScreen] = useState(false)
  const [windowWidth, setWindowWidth] = useState(document.documentElement.clientWidth)
  const [titleEdit, setTitleEdit] = useState(false)
  const [packageTitle, setPackageTitle] = useState('')
  const [timeline, setTimeline] = useState({})

  const { getPackage, getItems, updatePackage } = usePackage()

  const handleResize = () => {
    setWindowWidth(document.documentElement.clientWidth)
  }

  const getWindowWidth = () => {
    window.addEventListener('resize', handleResize)
  }

  const goBack = () => {
    if (page > 3) setPage(3)
    else props.history.push('/package?pkg=' + pkg?.packageId)
  }

  const setDeclarationState = () => {
    setEditDeclarationForm(true)
    setShippingAddrState(0)
  }

  const getItemsData = async (pkg) => {
    const response = await getItems({ packageId: pkg.packageId, disposition: pkg.disposition, type: pkg.type })
    const items = response.data
    setDeclarationState()
    setItems(items)
  }

  const getPackageData = async () => {
    try {
      setInitialLoading(1)
      const params = new URLSearchParams(props.location.search)
      const packageId = params.get('pkg')

      const response = await getPackage({ packageId })
      
      if (response.package.disposition === 1) {
        if (response.package.shipment.system === 99)
          props.history.replace('/done/packagePickup')
        else
          props.history.replace('/done/packageShipping')
      } else {
        if (response.package.consolidation) {
          await getItemsData(response.package)
        } else {
          const total = response.items.reduce((acc, item) => acc + item.itemFxValue, 0)
          setItems(response.items)
          const items = response.items
          if (items.length) setDeclarationState()
          else setEditDeclarationForm(false)
        }

        setPkg(response.package)
        setCustomsType(response.package.outgoingCustomsType)
        setFees(response.fees)
        setTimeline(response.timeline)
        setInitialLoading(2)

      }

    } catch (error) {
      if (error.response && error.response.status === 403) {
        props.logout()
        props.history.push('/login')
      } else {
        handleError(error)
      }
    }
  }

  const finishDeclaration = () => {
    const params = new URLSearchParams(props.location.search)
    const pkgId = params.get('pkg')
    props.history.push(`/checkout/${pkgId}`)
  }

  const finishAbandon = () => {
    const params = new URLSearchParams(props.location.search)
    const pkgId = params.get('pkg')
    props.history.push(`/abandon-checkout/${pkgId}`)
  }

  const savedDeclaredValue = (value) => {
    setModalScreen(false)
  }

  const closeDeclarationForm = () => {
    setEditDeclarationForm(false)
    setShippingAddrState(1)
    setModalScreen(false)
  }

  const saveCustoms = (value) => {
    setCustomsType(value)
  }

  const packageStatus = () => {
    if (GREEN_STATUS.includes(pkg?.status))
      return 'green'
    if (YELLOW_STATUS.includes(pkg?.status) || (pkg?.reqPhotographs === 1 && pkg?.reqPhotographsComplete === 0))
      return 'yellow'
    if (RED_STATUS.includes(pkg?.status))
      return 'red'
    return 'yellow'
  }

  const doSaveInfo = async () => {
    const UPDATED_PKG = {
      packageId: pkg?.packageId,
      customerTitle: packageTitle,
    }

    await updatePackage(UPDATED_PKG)

    setTitleEdit(false)
    setPkg({
      ...pkg,
      customerTitle: packageTitle,
    })
  }

  const doCancelSave = () => {
    setTitleEdit(false)
    setPackageTitle(pkg?.customerTitle)
  }

  useEffect(() => {
    getPackageData();
    getWindowWidth();
    window.scrollTo(0, 0)

    return () => {
      window.removeEventListener('resize', handleResize)
    };
  }, [])

  const SHOW_DECLARATION_FORM = (![1].includes(pkg?.consolidationStatus) && page < 4 && (!([3, 0].includes(pkg?.source) && pkg?.disposition === 6)));
  const SHOW_AUTO_CONSOLIDATION_MESSAGE = [1].includes(pkg?.consolidationStatus);
  const SHOW_PRERECEIVING_MESSAGE = [3, 0].includes(pkg?.source) && props.store.allowPreReceiving && pkg?.disposition === 6;

  if (initialLoading < 2)
    return (
      <div className="body">
        <CustomerSidebar />
        <CustomerLoading />
      </div>
    )
  else if (initialLoading > 2)
    return (
      <div className="body">
        <CustomerSidebar />
        <GlobalError />
      </div>
    )

  return (
    <div className={"body" + ((modalScreen || paymentScreen) ? ' modal-active' : '')} id="ship">
      <CustomerSidebar />
      <div className="package-content">
        <div className="page-title flex-column align-items-start">
          {page < 4 &&
            <div className="package-header">
              {SHOW_DECLARATION_FORM && <PhotoModal packageInfo={pkg} />}
              <div>
                <PageHeader title={pkg?.type === 1 ? `Combined Package #${String(pkg?.packageId || '').padStart(6, '0')}` : `Package #${String(pkg?.packageId || '').padStart(6, '0')}`} />
                {titleEdit ?
                  <div className="package-title-edit">
                    <input className="package-title-input" type="text" maxLength="45" value={packageTitle} onChange={(e) => { setPackageTitle(e.target.value) }} />
                    <div className="package-title-icon" onClick={doSaveInfo}><i><svg className="feather"><use href="/assets/images/icons/feather-sprite.svg#check" /></svg></i></div>
                    <div className="package-title-icon" onClick={doCancelSave}><i><svg className="feather"><use href="/assets/images/icons/feather-sprite.svg#x" /></svg></i></div>
                  </div>
                  :
                  (pkg?.customerTitle ?
                    <div className="package-customer-title pointer" onClick={() => { setTitleEdit(true) }}>
                      <div className="package-customer-title-text">{pkg?.customerTitle}</div>
                      <div className="edit-icon">
                        <i>
                          <svg className="feather"><use href="/assets/images/icons/feather-sprite.svg#edit" /></svg>
                        </i>
                      </div>
                    </div>
                    :
                    <div className="package-title-subtitle pointer" onClick={() => { setTitleEdit(true) }}>+ Give package a nickname/reference</div>
                  )
                }

              </div>
              <div className="checkout-pkg-action-buttons">
                {(pkg?.status?.toLowerCase() === 'pending consolidation' || pkg?.source === 5) && <CancelConsolidationModal packageInfo={pkg} history={props.history} />}
                {!!items.length && <RequestPhotoModal packageInfo={pkg} fees={fees} onFinishAbandon={finishAbandon}/>}
              </div>
              {!pkg?.consolidation && !items.length && pkg?.allowDelete && <CancelPrereceiveModal packageId={pkg?.packageId} history={props.history} />}
            </div>
          }
          {page === 31 && <PageHeader title={<div>Return Package</div>} />}
          {(page > 3 && page !== 31 && !returnOption) && <PageHeader title={<div> Review Shipment </div>} onBack={goBack} />}
          {(page > 3 && page !== 31 && returnOption) && <PageHeader title={<div> Review Shipment </div>} onBack={() => { setPage(31) }} />}
        </div>

        <hr className="page-divider"></hr>
        <div className="package-container">
          <div className="package-side" style={page === 4 ? { display: "none" } : {}}>
            <div className="package-side-content">
              {(page < 4) &&
                <div className="package-side-sticky">
                  <div className="package-info">
                    <div className="package-side-header">
                      <h4>Package Details</h4>
                      <div className="package-status-container">
                        <div className={`package-status ${packageStatus()}`}>
                          {(pkg?.reqPhotographs === 1 && pkg?.reqPhotographsComplete === 0) ? 'Awaiting additional photographs' : pkg?.status}
                        </div>
                      </div>
                    </div>
                    <div className={(pkg?.consolidation) ? 'package-card-consolidation' : 'package-card'}>
                      <div className="package-details">
                        <div className="package-info-item package-details-item package-info-toggle" onClick={() => { setWeightInLb(!weightInLb) }}>
                          <i><svg className="feather feather-light feather-small"><use href="/assets/images/icons/feather-sprite.svg#weight" /></svg></i>
                          <div className="package-info-content p-select">
                            <div className="package-info-content-title">
                              <span>Weight</span>
                              {pkg?.physical.weight && <div className="btn-toggle-small">
                                <button className={`btn ${weightInLb ? `btn-selected` : ``}`}>lb</button><button className={`btn ${weightInLb ? `` : `btn-selected`}`}>kg</button>
                              </div>}
                            </div>

                            {pkg?.physical.weight ?
                              <div className="package-info-status">
                                {weightInLb && <div>{weightImperial(pkg?.physical.weight)} lb</div>}
                                {!weightInLb && <div>{pkg?.physical.weight} kg</div>}
                              </div>
                              :
                              <div className="package-info-status">TBD</div>
                            }
                          </div>
                        </div>
                        <div className="package-info-item package-details-item package-info-toggle" onClick={() => { setDimensionInInch(!dimensionInInch) }}>
                          <i><svg className="feather feather-light feather-small"><use href="/assets/images/icons/feather-sprite.svg#box" /></svg></i>
                          <div className="package-info-content p-select" >
                            <div className="package-info-content-title">
                              <span>Dimensions</span>
                              {pkg?.physical.length && <div className="btn-toggle-small">
                                <button className={`btn ${dimensionInInch ? `btn-selected` : ``}`}>in</button><button className={`btn ${dimensionInInch ? `` : `btn-selected`}`}>cm</button>
                              </div>}
                            </div>
                            {pkg?.physical.length ?
                              <div>
                                {dimensionInInch && <div className="package-info-status" >{dimensionsImperial(pkg?.physical.length)} x {dimensionsImperial(pkg?.physical.width)} x {dimensionsImperial(pkg?.physical.height)} in</div>}
                                {!dimensionInInch && <div className="package-info-status" >{pkg?.physical.length} x {pkg?.physical.width} x {pkg?.physical.height} cm</div>}
                              </div>
                              :
                              <div className="package-info-status">TBD</div>
                            }
                          </div>
                        </div>
                      </div>
                      <div className="package-details">
                        <div className="package-info-item package-details-item">
                          <i><svg className="feather feather-light feather-small"><use href="/assets/images/icons/feather-sprite.svg#map-pin" /></svg></i>
                          <div className="package-info-content">
                            <span>Warehouse</span>
                            <div className="package-info-status">
                              {warehouseData(pkg?.warehouse).name}
                            </div>
                          </div>
                        </div>
                        <div className="package-info-item package-details-item">
                          <i><svg className="feather feather-light feather-small"><use href="/assets/images/icons/feather-sprite.svg#calendar" /></svg></i>
                          {pkg?.consolidation ?
                            <div className="package-info-content">
                              <span>Requested On</span>
                              <div className="package-info-status">{displayDate(convertToClientTimestamp(pkg?.created), "d MMM yyyy")}</div>
                            </div>
                            :
                            <div className="package-info-content">
                              <span>Received On</span>
                              <div className="package-info-status">{displayDate(convertToClientTimestamp(pkg?.incoming?.received), "d MMM yyyy")}</div>
                            </div>
                          }
                        </div>
                        {pkg?.hazmatName && <div className="package-info-item package-details-item">
                          <i><svg className="feather feather-light feather-small"><use href="/assets/images/icons/feather-sprite.svg#alert-octagon" /></svg></i>
                          <div className="package-info-content">
                            <span>Hazmat Description</span>
                            <div className="package-info-status">
                              {pkg?.hazmatName}
                            </div>
                          </div>
                        </div>}
                      </div>
                      {!pkg?.consolidation &&
                        <div className="package-details">
                          <div className="package-info-item package-details-item">
                            <i><svg className="feather feather-light feather-small"><use href="/assets/images/icons/feather-sprite.svg#shopping-bag" /></svg></i>
                            <div className="package-info-content">
                              <span>Store/Vendor</span>
                              <div className="package-info-status">{pkg?.incoming?.vendor}</div>
                            </div>
                          </div>
                          <div className="package-info-item package-details-item">
                            <i><svg className="feather feather-light feather-small"><use href="/assets/images/icons/feather-sprite.svg#truck" /></svg></i>
                            <div className="package-info-content">
                              <span>Carrier</span>
                              <div className="package-info-status">{carrierLabel(pkg?.incoming?.carrier)}</div>
                            </div>
                          </div>
                        </div>}
                      {(pkg?.consolidation) &&
                        <div className="package-details package-consolidation">
                          <div className="package-info-item package-details-item">
                            <i>
                              <svg className="feather feather-light feather-small">
                                <use href="/assets/images/icons/feather-sprite.svg#package" />
                              </svg>
                            </i>
                            <div className="package-info-content">
                              <span>Packages Combined</span>
                              <table>
                                <thead>
                                  <tr>
                                    <th>ID</th>
                                    <th>Vendor</th>
                                    <th>Received</th>
                                  </tr>
                                </thead>
                                <tbody>
                                  {!!pkg?.subpackages && pkg?.subpackages.map((pkg, index) => {
                                    return (
                                      <tr key={`subPackage-${index}-${pkg.packageId}`}>
                                        <td>
                                          #{pkg.packageId.toFixed().padStart(6, '0')}
                                        </td>
                                        <td key={`subPackage-${index}-${pkg.vendor}`}>
                                          {pkg.vendor}
                                        </td>
                                        <td key={`subPackage-${index}`}>
                                          {displayDate(convertToClientTimestamp(pkg.received), "d MMM yyyy")}
                                        </td>
                                      </tr>
                                    )
                                  })
                                  }
                                </tbody>
                              </table>
                            </div>
                          </div>
                        </div>}
                    </div>
                    {!pkg?.consolidation && <div className="package-info-item tracking-number">
                      <div className="package-info-status">
                        {props.store.allowPreReceiving && <TimelineModal timelineData={timeline} />}
                        {!props.store.allowPreReceiving && (pkg?.incoming?.tracking ? <TrackingLink trackingLink={pkg?.incoming.trackingLink} tracking={pkg?.incoming.tracking} /> : 'Not yet available.')}
                      </div>
                    </div>}
                  </div>
                </div>}
            </div>
          </div>
          <div className="package-main">

            {(!pkg?.shipped && !!pkg?.restrictDomesticOnly && pkg?.restricted !== 27) &&
              <div className="notice notice-warn">
                <i><svg className="feather"><use href="/assets/images/icons/feather-sprite.svg#alert-triangle" /></svg></i>
                <div className="notice-content">Due to export restrictions, this package can only be shipped within the same country. Your shipping addresses have been filtered accordingly.</div>
              </div>
            }
            {(!pkg?.shipped && !!pkg?.restrictGroundOnly && pkg?.restricted !== 26) &&
              <div className="notice notice-warn">
                <i><svg className="feather"><use href="/assets/images/icons/feather-sprite.svg#alert-triangle" /></svg></i>
                <div className="notice-content">Due to carrier restrictions, this package can only be shipped via surface delivery methods.</div>
              </div>
            }
            {(!pkg?.shipped && !!restrictionStatus(pkg?.restricted)) &&
              <div className="notice notice-warn">
                <i><svg className="feather"><use href="/assets/images/icons/feather-sprite.svg#alert-triangle" /></svg></i>
                <div className="notice-content">{restrictionStatus(pkg?.restricted)}</div>
              </div>
            }
            {(!pkg?.shipped && !!pkg?.restrictPickupOnly) &&
              <div className="notice notice-warn">
                <i><svg className="feather"><use href="/assets/images/icons/feather-sprite.svg#alert-triangle" /></svg></i>
                <div className="notice-content">Due to export restrictions, this package can only be picked up from Reship warehouse. Your shipping addresses have been filtered accordingly.</div>
              </div>
            }
            {
              SHOW_AUTO_CONSOLIDATION_MESSAGE ? (
                <div className='package-card'>
                  <div style={{
                    display: 'flex',
                    flexDirection: 'column',
                    alignItems: 'center',
                    textAlign: 'center',
                    maxWidth: '100%',
                    padding: '20px'
                  }}>
                    <img
                      src="/assets/images/5.svg"
                      alt='pending-cons'
                      style={{
                        width: '100%',
                        maxWidth: '400px',
                        height: 'auto',
                        borderRadius: '100px'
                      }}
                    />
                    <h3 className='mt-3'>We're working on it!</h3>
                    <p className='mt-1' style={{
                      width: '100%',
                      maxWidth: '500px',
                      minWidth: '200px',
                      wordWrap: 'break-word'
                    }}>
                      Our team is working on your consolidation, please check back later. Be aware that this process can take more than 24 hours.
                    </p>
                  </div>
                </div>
              ) : null
            }
            {
              SHOW_PRERECEIVING_MESSAGE ? (
                <div className='package-card'>
                  <div style={{
                    display: 'flex',
                    flexDirection: 'column',
                    alignItems: 'center',
                    textAlign: 'center',
                    maxWidth: '100%',
                    padding: '20px'
                  }}>
                    <img
                      src={pkg?.status === 'Arrived' ? "/assets/images/5.svg" : "/assets/images/7.svg"}
                      alt='pending-cons'
                      style={{
                        width: '100%',
                        maxWidth: '400px',
                        height: 'auto',
                        borderRadius: '100px'
                      }}
                    />
                    <h3 className='mt-3'>{pkg?.status === 'Arrived' ? "We're processing your package" : "Your package is on the way!"}
                    </h3>
                    <p className='mt-1'
                      style={{
                        width: '100%',
                        maxWidth: '500px',
                        minWidth: '200px',
                        wordWrap: 'break-word'
                      }}>
                      {pkg?.status !== 'Arrived' && 'We are waiting for your package!'} Track it for the latest updates. Be aware that processing may take up to 24 hours.
                    </p>
                    <TimelineModal timelineData={timeline} />
                  </div>
                </div>
              ) : null
            }
            {SHOW_DECLARATION_FORM &&
              <div className={`package-card ${(!items.length ? "package-default" : (editDeclarationForm ? "package-current" : "package-complete"))}`}>
                <div className="declared-form">
                  {windowWidth > 768 ?
                    (editDeclarationForm &&
                    <ItemsDeclarationForm pkg={pkg} type={'checkout'}
                      pkgCustomsType={customsType} saveAction={() => { }} setEdit={() => { }} saveValue={savedDeclaredValue} closeAction={closeDeclarationForm}
                      saveCustoms={saveCustoms} onFinish={finishDeclaration}
                    />)
                    :
                    <MobileDeclarationForm pkg={pkg} pkgCustomsType={customsType}
                      saveValue={savedDeclaredValue}
                      openForm={editDeclarationForm}
                      closeAction={closeDeclarationForm} saveCustoms={saveCustoms}
                      onFinish={finishDeclaration}
                      
                      />
                  }
                </div>
              </div>
            }
          </div>
        </div>

      </div>
      <GlobalFooter />
    </div>
  )
}

export default connect(mapStateToProps, mapDispatchToProps)(withRouter(withAddressAutocomplete(Checkout)))
